<div class="pdfjs-viewer">
  <div class="loader nested" *ngIf="status == STATUS_LOADING">
    <div class="dimmed">
      <div class="dimmed_box"></div>
      <div class="dimmed_box_large"></div>
    </div>
  </div>

  <core-helpers-box-alert-message-icon [hidden]="status != STATUS_NOT_FOUND" [text]="'No preview available'"
    [icon]="'alert'"></core-helpers-box-alert-message-icon>
  <!-- The PDFjs will be binded in UI to this element. -->
  <div #viewer class="viewer"></div>
</div>